import "./RevenueCalculator.module.css";
import Header from "@/reusable_sections/Header";
import RevparCalculator from "./sections/RevparCalculator";
import RevenueCalculator from "./sections/RevenueCalculator";
import Footer from "@/reusable_sections/Footer";
export default function RevenueCalculatorPage() {
  return <div>
      <Header />
      <RevparCalculator />
      <RevenueCalculator />
      <Footer />
    </div>;
}